import _focusableRef from './focusable-ref'

/**
 * React Native Web can call .focus() on almost any interactive element, while React Native
 * can only call .focus() on TextInputs and will throw '"No command found with name "focus"'
 * for anything else.
 *
 * This utility always returns the ref on web, and only returns TextInput refs on native.
 */
export const focusableRef = _focusableRef
